export function isLocalStorageAvailable() {
	const test = "test"
	try {
		localStorage.setItem(test, test)
		localStorage.removeItem(test)
		return true
	} catch (e) {
		return false
	}
}

export function isSessionStorageAvailable() {
	const test = "test"
	try {
		sessionStorage.setItem(test, test)
		sessionStorage.removeItem(test)
		return true
	} catch (e) {
		return false
	}
}

export function isNavigatorAvailable() {
	try {
		navigator.language
		return true
	} catch (e) {
		return false
	}
}

export function isBufferAvailable() {
	try {
		Buffer.from("SGVsbG8gV29ybGQ=", 'base64').toString('utf8')
		return true
	} catch (e) {
		return false
	}
}

export function isAtobAvailable() {
	try {
		let text = "Hello World!";
		let encoded = window.btoa(text);
		let decoded = window.atob(encoded);
		return true;
	}
	catch (e) {
		return false
	}
}

export function isHistoryAvailable() {
	try {
		history.state
		return true
	} catch (e) {
		return false
	}
}